module.exports = __webpack_public_path__ + "static/media/rolled_out.3b48e7d8.png";